import { render } from "./AlertError.vue?vue&type=template&id=ddaac62c&scoped=true"
import script from "./AlertError.vue?vue&type=script&lang=js"
export * from "./AlertError.vue?vue&type=script&lang=js"

import "./AlertError.vue?vue&type=style&index=0&id=ddaac62c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddaac62c"]])

export default __exports__